export default "__VITE_ASSET__D3P1wqRn__"